// Removes a lawn program "parent" line item from the Rebuy cart when its
// bundled child line item (added via sms-form.js) is no longer present.
(function () {
    // Bundle ids seen with both the parent and child line item present.
    // Only bundles that were actually complete at some point are eligible
    // to trigger an auto-removal, so a misconfigured parent-only add never
    // gets removed the moment it lands in the cart.
    var seenPaired = {};
    var removing = {};

    function isParentItem(item) {
        return !!(item.properties && item.properties['Includes (as seen below)']);
    }

    function isChildItem(item) {
        return !!(item.properties && item.properties['Included with']);
    }

    function bundleId(item) {
        return item.properties && item.properties['_bundle_id'];
    }

    function syncBundles(cart) {
        if (!cart || !Array.isArray(cart.items) || !window.Rebuy || !window.Rebuy.Cart) {
            return;
        }

        var childBundleIds = {};
        cart.items.forEach(function (item) {
            var id = bundleId(item);
            if (isChildItem(item) && id) {
                childBundleIds[id] = true;
            }
        });

        cart.items.forEach(function (item) {
            var id = bundleId(item);
            if (!isParentItem(item) || !id) {
                return;
            }

            if (childBundleIds[id]) {
                seenPaired[id] = true;
                return;
            }

            if (!seenPaired[id] || removing[id]) {
                return;
            }

            removing[id] = true;
            window.Rebuy.Cart.removeItem(item, function () {
                delete removing[id];
                delete seenPaired[id];
            });
        });
    }

    document.addEventListener('rebuy:cart.ready', function (event) {
        var cart = event.detail && event.detail.cart && event.detail.cart.cart;
        syncBundles(cart);
    });

    document.addEventListener('rebuy:cart.change', function (event) {
        var cart = event.detail && event.detail.cart && event.detail.cart.cart;
        syncBundles(cart);
    });
})();
